import React from 'react'
import Checkbox from '../checkbox';

export default function StoreLocatorFilter({isStoreChecked, isLockerChecked, isInpostTracking, toggleFilter}) {
  return (
    <div className="store-locator-filter">
      <div className="store-locator-filter__title-block">
        {!isInpostTracking && 
          <img src="/assets/store-locator/filter-icon.svg" />
        }
        <span>{`Filter by${isInpostTracking ? ":" : ""}`}</span>
      </div>
      <Checkbox
        id="lockers-checkbox"
        checked={isLockerChecked}
        onChange={() => toggleFilter("in_post_locker")}>
        {isInpostTracking &&
          <img className="checkbox-option-icon" src="/assets/inpost-assets/locker_icon.svg" alt="inpost-locker-icon" />
        }
        {isInpostTracking ? "Lockers" : "InPost Lockers"}
      </Checkbox>
      <Checkbox
        id="stores-checkbox"
        checked={isStoreChecked}
        onChange={() => toggleFilter("paypoint")}>
        {isInpostTracking &&
          <img className="checkbox-option-icon" src="/assets/inpost-assets/shop_icon.svg" alt="inpost-shop-icon" />
        }
        {isInpostTracking ? "Shops" : "Yodel Stores"}
      </Checkbox>
    </div>
  )
}
